var map = {
	"./(tabs)/_layout.tsx": 35012,
	"./(tabs)/ai-assistant.tsx": 3013,
	"./(tabs)/index.tsx": 56061,
	"./(tabs)/learning-analysis.tsx": 56473,
	"./(tabs)/profile.tsx": 82667,
	"./(tabs)/study-plan.tsx": 26977,
	"./(tabs)/wrong-questions.tsx": 77271,
	"./_layout.tsx": 11914,
	"./all-functions.tsx": 84582,
	"./analysis-result.tsx": 68141,
	"./ancient-text-analysis.tsx": 13502,
	"./answer-detail.tsx": 89569,
	"./calculator.tsx": 71489,
	"./conversation-history.tsx": 13911,
	"./diagram-question.tsx": 51153,
	"./exam-detail.tsx": 39710,
	"./exam-result.tsx": 79928,
	"./exam-upload.tsx": 23616,
	"./feature-under-development.tsx": 1226,
	"./flashcards.tsx": 94074,
	"./games/idiom-battle.tsx": 15790,
	"./games/oral-calculation.tsx": 28621,
	"./games/poetry-contest.tsx": 76909,
	"./grade-select.tsx": 11691,
	"./growth-trajectory.tsx": 22108,
	"./homework-correction.tsx": 29738,
	"./knowledge-graph.tsx": 65334,
	"./learning-records.tsx": 1726,
	"./login.tsx": 41023,
	"./mock-exam.tsx": 15835,
	"./notes.tsx": 30226,
	"./onboarding.tsx": 81770,
	"./paper-analysis.tsx": 58820,
	"./photo-search.tsx": 94534,
	"./question-collection.tsx": 40112,
	"./ranking.tsx": 74247,
	"./search-result-list.tsx": 90694,
	"./settings.tsx": 85234,
	"./smart-practice.tsx": 63022,
	"./subject-analysis.tsx": 57354,
	"./theme-settings.tsx": 37370,
	"./weakness-improvement.tsx": 17339,
	"./word-lookup.tsx": 45714,
	"./wrong-question-practice.tsx": 87830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48524;